<template>
    <div>
      <!-- <tl-header type="h1">
        <div>Selected Employee Bulk Upload</div>
      </tl-header> -->
      <!-- <div class="uploadMethoRadio">
        <tl-radio
          name="uploadMethod"
          label="Bulk Upload"
          id="bulkUpload"
          value="bulkUpload"
          v-model="uploadMethod"
        />
  
        <tl-radio
          name="uploadMethod"
          label="Manual"
          id="manualUpload"
          value="manualUpload"
          v-model="uploadMethod"
        />
      </div> -->
  
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
  
      <div v-if="uploadMethod === 'bulkUpload'">
        <div class="download-btn">
          <!-- <download-button
            onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Template-+One+time+payment+and+deduction.xlsx'"
          ></download-button> -->
            <download-button class="downloadTemplateButton" @downloadTemplate="getEmployeeTemplate()"></download-button>    
        </div>
        <div class="margintop-20 margin-bottom-50" :key="componentKey">
          <!-- <upload-file @uploadTemplate="onUploadTemplate($event)" /> -->
          <!-- <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" /> -->
          <upload :tobucket="false" ref="bulkFile" @change="onUploadTemplate($event)"></upload>
        </div>
      </div>
      <!-- <div class="lock-list">
        <tl-checkbox label="Lock Selected Employee Bulk Upload List" @change="(bool)=>{locklist(bool)}"></tl-checkbox>
      </div> -->
      <pop-up-message
        v-if="showErrorPopup"
        message=""
        popupType="Warning"
        :popupHeaderMessage="'UPLOAD FAILED!!!'"
  
      >
          <template v-slot:bottomContent>
          <div class=" margintop-32">
            <div class="Rectangle margintop-32">
            <span class="Information-message">{{ logMessage }}</span>
            </div>
      </div>
      <div class="margintop-32 custom-container">
      <a :href="logSheetUrl"
        @click="downloadItem(logSheetUrl)"
      ><img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
          </div>
  
          <div class="popup-btn-group margintop-32 marginright">
  
            <button class="btn-popup" type="button" @click="backfromlogpopup()">Back To Select Employees</button>
  
           <!-- <button class="btn-popup" type="button" @click="uploadFile2($event)">Proceed</button>
                -->  </div>
        </template>
      </pop-up-message>
  
      <pop-up-message
        v-if="showBulkUploadSuccessMsg"
        :message="`${popupMessage}`"
        btnText="Back"
        @back="back"
      ></pop-up-message>
  
      <pop-up-message
        v-if="showSuccessMsg"
        :message="popupMsg"
        btnText="Back"
        @back="backfrompopup()"
      />
    </div>
  </template>
  
  
  <script>
  import { mapActions, mapGetters, mapState } from "vuex";
  import SearchDropdown from "@/components/TlSearchDropdown.vue";
  import { throws } from "assert";
  import { api_variables } from "@/apis/variables.js";
  
  export default {
    name: "selectedEmployee",
    components: { SearchDropdown },
    data() {
      return {
        bulkUploadUrl: api_variables.SERVICE_PAYMENT_DEDUCTION_UPLOAD_TEMPLATE,
        errmsg: "",
        toast: false,
        showSuccessMsg: "",
        popupMsg: "",
  
        popupMessage: "",
        showBulkUploadSuccessMsg: false,
  
        formData: {
          amount: null,
          month: "",
          componentObj: null,
          actionObj: null,
          yearObj: null,
          monthObj: null
        },
  
        countObj: {
          payGroupsSelected: 0,
          totalEmployeesSelected: 0,
          eligibleEmployeesSelected: 0,
  
          totalPayGroups: 0,
          totalEmployees: 0,
          totalEligibleEmployees: 0
        },
  
        searchText: "",
        componentsList: [],
        selectedEmpData: null,
        uploadMethod: "bulkUpload",
        isLocked: false,
        month: "",
        component: "",
        empName: "",
        empId: "",
        amount: "",
        employeeData: [],
        allMonthsArray: [
          { name: "January", id: "jan" },
          { name: "February", id: "feb" },
          { name: "March", id: "mar" },
          { name: "April", id: "apr" },
          { name: "May", id: "may" },
          { name: "June", id: "jun" },
          { name: "July", id: "jul" },
          { name: "August", id: "aug" },
          { name: "September", id: "sep" },
          { name: "October", id: "oct" },
          { name: "November", id: "nov" },
          { name: "December", id: "dec" }
        ],
        yearsListArray: [],
        employeeSalaryComponents: [],
        showErrorPopup:false,
        logSheetUrl: null,
        logMessage: null,
        componentKey: 0,
        ss_id: null,
      };
    },
    activated() {
      this.uploadMethod = "bulkUpload";
    },
    mounted() {},
    beforeDestroy() {
    },
    computed: {
      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID"
      }),
      ...mapState({
        payrollMonth: state => state.payroll.runpayroll.payrollMonth,
        payrollYear: state => state.payroll.runpayroll.payrollYear
      }),
      le_id() {
        if (this.$route.params.entity_index)
          return this.getleid(this.$route.params.entity_index);
        else return this.getleid(0);
      },
  
      orgId() {
        return this.$store.getters["onboard/getOrgId"];
      }
    },
    methods: {
      ...mapActions({
       // act_upload_template: "payroll/selectedemployee/fileuploadTemplate",
        act_upload_template_new: "payroll/selectedemployee/fileuploadTemplateNew",
        fetch_template: "payroll/selectedemployee/getEmployeeTemplate",
      }),
  
      skip() {
        this.$router.push({
          path: `/payroll/run/${this.$route.params.entity_index}/summary`
        });
      },
  
      backfrompopup() {
        this.showSuccessMsg = false;
      },
  
      backfromlogpopup(){
        this.showErrorPopup = false;
        this.componentKey += 1;
      },
       /** To lock/unlock the 'Next' button */
      locklist(ee) {
        if (ee) {
          this.isLocked = true;
        } else {
          this.isLocked = false;
        }
      },
      /** Navigation */
      cancel() {
        this.$router.push({
          path: `/payroll/run/${this.$route.params.entity_index}/tds`
        });
      },
  
      save() {
        this.performAction("next");
      },
  
      async getEmployeeTemplate() {
        try {
        let data={
            le_id : this.le_id,
            // financial_year: this.payrollYear,
            // month: this.payrollMonth.slice(0, 3).toLowerCase()
          }
          let res = await this.fetch_template(data);
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
      /***** BULK UPLOAD Previous implementation *****/
      
      async onUploadTemplate(event) {
        let fy = this.payrollYear;
        let formData = new FormData();
        formData.append("file", event);
        formData.append("le_id", this.le_id);
        //formData.append("financial_year", fy);
  
        try {
          //let res = await this.act_upload_template(formData); // this is old api
          let res = await this.act_upload_template_new(formData); 
          // this is new api
          if (res.data.statusCode == 200) {
            this.popupMessage = res.data.message ? res.data.message : "";
            this.$refs.bulkFile.uploaded = true;
            this.$refs.bulkFile.uploading = false;
            this.showBulkUploadSuccessMsg = true;
            this.showErrorPopup = false;
          }
          // } else if(res.data.status != 200){
          //   //console.log("entryyyy");
          //   this.logSheetUrl = res.data.payload.error.payload;
          //   this.showErrorPopup = true;
          // }
        } catch (error) {
          // this.showErrorPopup = true;
          // this.logSheetUrl = error.payload.error.payload;
          // this.logMessage = error.message;
        }
      },
      
     /***** BULK UPLOAD Current implementation *****/
      // async onUploadTemplate(res) {
      //   //console.log()
      //   try {
      //     if (res.data && res.data.status) {
      //       this.popupMessage = res.data.message ? res.data.message : "";
      //       this.showBulkUploadSuccessMsg = true;
      //     } else {
      //       this.toast = true;
      //       this.errmsg = res.message;
      //     }
      //   } catch (err) {
      //     this.$root._data.isSaving = false;
      //     this.toast = true;
      //     this.errmsg = err;
      //   }
      // },
  
      back() {
        this.showBulkUploadSuccessMsg = false;
        //this.$router.go(0);
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  @import "@/scss/dashboard/_variables.scss"; // Common
  @import "@/scss/dashboard/content/_section.scss"; // Content Section
  
  .paygrpsDiv {
    display: flex;
    cursor: pointer;
    padding: 40px 0px;
  
    span {
      color: #646464;
      font-size: 16px;
    }
    > :nth-child(n) {
      margin-right: 64px;
    }
    > :last-child {
      margin-right: 0px;
    }
  }
  .downloadTemplateButton{
    display: inline;
  }
  .paygrps-info {
    color: #646464;
    cursor: pointer;
    text-align: center;
    margin-top: 5px;
    b {
      font-size: 24px;
      font-weight: 500;
    }
  }
  .paygrp {
    background: #fbfbfb;
    width: 31%;
    height: 85px;
    border-radius: 2px;
    border: solid 1px #37c6c0;
    padding: 20px;
    text-align: center;
    display: flex;
    justify-content: inherit;
  }
  .alignPaygrp {
    padding: 20px;
    text-align: center;
  }
  .d-marginBottom {
    margin-bottom: 7px;
  }
  .line {
    border-bottom: 1px solid #c8c8c8;
    width: 100%;
    margin-bottom: 20px;
  }
  .uploadMethoRadio {
    margin-top: 30px;
    display: flex;
    margin-top: 2%;
  }
  .label {
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 8px;
    color: #6e6e6e;
  }
  .download-btn {
    margin-top: 2%;
  }
  .payslips {
    width: 37%;
  }
  .aligntext {
    text-align: center;
  }
  .lock-list {
    margin-top: 2%;
    display: flex;
    span {
      margin-top: 2px;
    }
  }
  .noofdays {
    input {
      border-radius: 4px;
      border: 1px solid #dadada;
      padding: 10px;
      width: 150px;
      height: 35px;
      transition: ease-in-out, width 0.35s ease-in-out;
  
      &:focus {
        outline: none;
        border: 2px solid #34c0be;
      }
    }
  }
  .month {
    margin-left: 0%;
  }
  .margin-top-30 {
    margin-top: 30px;
  }
  .margin-top-20 {
    margin-top: 20px;
  }
  .margin-top-10 {
    margin-top: 10px;
  }
  .customGrid1 {
    display: grid;
    grid-template-columns: 26% 26% 26%;
    grid-row-gap: 15px;
    grid-column-gap: 20px;
  }
  .customGrid2 {
    display: grid;
    grid-template-columns: 22% 22% 22%;
    grid-row-gap: 15px;
    grid-column-gap: 20px;
  }
  .margin-bottom-50 {
    margin-bottom: 50px;
  }
  .custom-width {
    width: 80%;
  }
  </style>
  
  